import { LoginBody, LoginResponse } from "../../sdk/types"

import { Action } from "./reducer"
import { Dispatch } from "react"
import client from "../../utils/client"
import { deleteCookie } from "../../utils/cookie"

const login = async (
    dispatch: Dispatch<Action>,
    body: LoginBody,
    options: { onSuccess: (response: LoginResponse) => void; onError: (error: unknown) => void }
) => {
    try {
        dispatch({ type: "REQUEST_LOGIN" })
        const response = await client.login(body)
        dispatch({ type: "LOGIN_SUCCESS" })
        options && options.onSuccess(response)
        return
    } catch (error) {
        options && options.onError(error)
        dispatch({ type: "ERROR", error: error })
        if (client.state.customerWeakToken) logout(dispatch)
    }
}

const logout = (dispatch: Dispatch<Action>) => {
    try {
        dispatch({ type: "LOGOUT" })
        client.logout()
        deleteCookie("__is_partner__")
        return
    } catch (error) {
        dispatch({ type: "ERROR", error: error })
    }
}

const switchToCustomer = (dispatch: Dispatch<Action>) => {
    return dispatch({ type: "SWITCH_TO_CUSTOMER" })
}

const updateIsInitialLoad = (dispatch: Dispatch<Action>) => {
    return dispatch({ type: "UPDATE_IS_INITIAL_LOAD" })
}

export { login, logout, switchToCustomer, updateIsInitialLoad }
